export default  {"src":"/_next/static/image/public/assets/nevo-boi/chevron-left.5e754a0eee0c57a783e85d2ef0d50263.svg","height":22,"width":22};